import { useEffect, useState } from "react"
import styled from "styled-components"
import AdminService from "../../../services/admin.service"

// Pendientes de catalogo: cada respuesta de un supervisor a un aviso del bot.
// Es demanda real — lo que el catalogo no tiene o no explica. No se convierte
// sola en regla: David decide aqui donde va cada una y la marca resuelta.

interface Pendiente {
    id: number; session_id: string; consulta?: string; respuesta: string;
    supervisor?: string; destino_sugerido: string; creado_en: string;
    resuelto_en?: string; resuelto_por?: string;
    nombre?: string; origen?: string; wa_id?: string; correo?: string;
}
interface Msg { role: string; nombre_agente?: string; contenido: string }

const DESTINOS: { v: string; label: string }[] = [
    { v: "tour_nuevo", label: "Tour nuevo" },
    { v: "faq", label: "FAQ" },
    { v: "blog", label: "Blog" },
    { v: "regla", label: "Regla" },
    { v: "otro", label: "Otro / puntual" },
]

const fechaCorta = (s?: string) => s ? new Date(s).toLocaleString("es-CL", { dateStyle: "short", timeStyle: "short" }) : ""

export default function Pendientes() {
    const [resueltos, setResueltos] = useState(false)
    const [items, setItems] = useState<Pendiente[]>([])
    const [loading, setLoading] = useState(false)
    const [abierta, setAbierta] = useState<number | null>(null)
    const [conv, setConv] = useState<Msg[]>([])
    const [error, setError] = useState("")

    const load = async () => {
        setLoading(true); setError("")
        try { const { data } = await AdminService.getBotPendientes(resueltos); setItems(Array.isArray(data) ? data : []) }
        catch { setItems([]); setError("No se pudieron cargar los pendientes") }
        finally { setLoading(false) }
    }
    useEffect(() => { load(); setAbierta(null) }, [resueltos]) // eslint-disable-line react-hooks/exhaustive-deps

    const actualizar = async (p: Pendiente, data: { resuelto?: boolean; destino?: string }) => {
        try { await AdminService.updateBotPendiente(p.id, data); await load() }
        catch { setError("No se pudo guardar el cambio") }
    }

    const verConversacion = async (p: Pendiente) => {
        if (abierta === p.id) { setAbierta(null); return }
        setAbierta(p.id); setConv([])
        try { const { data } = await AdminService.getBotConversation(p.session_id); setConv(Array.isArray(data) ? data : []) }
        catch { setConv([]) }
    }

    return (
        <Wrap>
            <Head>
                <div className="toggle">
                    <button className={!resueltos ? "active" : ""} onClick={() => setResueltos(false)}>Por revisar</button>
                    <button className={resueltos ? "active" : ""} onClick={() => setResueltos(true)}>Resueltos</button>
                </div>
                <span>{items.length} {resueltos ? "resueltos" : "por revisar"}</span>
                <button className="refresh" onClick={load}>&#8635;</button>
            </Head>
            <Hint>Cada respuesta tuya o de Operaciones a un aviso del bot queda acá. Es lo que el catálogo no tiene o no explica: decide si va como tour nuevo, FAQ, blog o regla, y márcala resuelta.</Hint>
            {error && <ErrorMsg>{error}</ErrorMsg>}
            {loading && <Empty>Cargando…</Empty>}
            {!loading && items.length === 0 && <Empty>{resueltos ? "Nada resuelto todavía" : "No hay pendientes por revisar 🎉"}</Empty>}
            {items.map(p => (
                <Card key={p.id} className={p.resuelto_en ? "done" : ""}>
                    <div className="meta">
                        <strong>{p.nombre || "Sin nombre"}</strong>
                        <span>{p.origen === "whatsapp" ? (p.wa_id ? `+${p.wa_id}` : "WhatsApp") : (p.correo || "chat web")}</span>
                        <span>· {fechaCorta(p.creado_en)}</span>
                    </div>
                    {p.consulta && <p className="q"><b>❓ Consulta:</b> {p.consulta}</p>}
                    <p className="a"><b>↩️ {p.supervisor || "Supervisor"} respondió:</b> {p.respuesta}</p>
                    <div className="row">
                        <label>Destino
                            <select value={p.destino_sugerido} onChange={e => actualizar(p, { destino: e.target.value })}>
                                {DESTINOS.map(d => <option key={d.v} value={d.v}>{d.label}</option>)}
                            </select>
                        </label>
                        <button className="ghost" onClick={() => verConversacion(p)}>{abierta === p.id ? "Ocultar conversación" : "Ver conversación"}</button>
                        {p.resuelto_en
                            ? <button className="ghost" onClick={() => actualizar(p, { resuelto: false })}>Reabrir</button>
                            : <button className="main" onClick={() => actualizar(p, { resuelto: true })}>Marcar resuelto</button>}
                    </div>
                    {p.resuelto_en && <span className="done-tag">Resuelto {fechaCorta(p.resuelto_en)}{p.resuelto_por ? ` por ${p.resuelto_por}` : ""}</span>}
                    {abierta === p.id && (
                        <Chat>
                            {conv.length === 0 && <Empty>Cargando conversación…</Empty>}
                            {conv.map((m, i) => (
                                <div key={i} className={`m ${m.role}`}>
                                    {m.role === "supervisor" && <em>Instrucción interna de {m.nombre_agente || "el equipo"}</em>}
                                    {m.role === "human_agent" && <em>{m.nombre_agente || "Agente"}</em>}
                                    <span>{m.contenido}</span>
                                </div>
                            ))}
                        </Chat>
                    )}
                </Card>
            ))}
        </Wrap>
    )
}

const Wrap = styled.div`height:100%;overflow-y:auto;display:flex;flex-direction:column;gap:10px;`
const Head = styled.div`
display:flex;align-items:center;gap:12px;font-size:13px;color:#8B7355;
.toggle{display:flex;gap:4px;}
.toggle button{border:1px solid #e3ddd2;background:#fff;color:#8B7355;border-radius:14px;padding:5px 12px;cursor:pointer;font-size:12px;}
.toggle button.active{background:#C4622D;border-color:#C4622D;color:#fff;}
.refresh{margin-left:auto;border:none;background:#f2ebe0;border-radius:8px;width:28px;height:28px;cursor:pointer;}
`
const Hint = styled.p`margin:0;font-size:12px;color:#A09070;line-height:1.5;`
const ErrorMsg = styled.div`font-size:12px;color:#9E4A1E;background:#fce4d6;border-radius:8px;padding:6px 10px;`
const Empty = styled.div`color:#A09070;font-size:13px;text-align:center;padding:24px;`
const Card = styled.div`
border:1px solid #e3ddd2;border-radius:10px;padding:12px 14px;background:#fff;display:flex;flex-direction:column;gap:6px;
&.done{opacity:.7;}
.meta{display:flex;gap:6px;align-items:baseline;flex-wrap:wrap;font-size:12px;color:#8B7355;}
.meta strong{font-size:14px;color:#2D2318;}
p{margin:0;font-size:13px;line-height:1.5;color:#3c352b;white-space:pre-wrap;}
p.q{background:#faf7f1;border-radius:8px;padding:6px 10px;}
.row{display:flex;gap:8px;align-items:center;flex-wrap:wrap;margin-top:2px;}
label{font-size:12px;color:#8B7355;display:flex;align-items:center;gap:6px;}
select{border:1px solid #d9cfbf;border-radius:8px;padding:5px 8px;font-size:12px;background:#fff;}
button{border:none;border-radius:8px;padding:6px 12px;cursor:pointer;font-size:12px;}
button.main{background:#C4622D;color:#fff;margin-left:auto;}
button.ghost{background:#f2ebe0;color:#8B7355;}
.done-tag{font-size:11px;color:#3c6b2f;}
`
const Chat = styled.div`
margin-top:6px;border-top:1px solid #efe8dc;padding-top:8px;display:flex;flex-direction:column;gap:6px;max-height:360px;overflow-y:auto;
.m{max-width:85%;padding:6px 10px;border-radius:10px;font-size:12px;line-height:1.45;white-space:pre-wrap;}
.m em{display:block;font-size:10px;font-style:normal;font-weight:600;margin-bottom:2px;}
.m.user{align-self:flex-end;background:#C4622D;color:#fff;}
.m.assistant{align-self:flex-start;background:#faf7f1;border:1px solid #e3ddd2;color:#2D2318;}
.m.human_agent{align-self:flex-start;background:#fff4ec;border:1px solid #f0c9b0;color:#2D2318;}
.m.supervisor{align-self:center;background:#fffbe6;border:1px dashed #d9c48a;color:#6b5b24;}
`
